import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { customTextColor } from "../../../utils/const";
import { Box, Grid, Typography } from "@mui/material";
import styles from "../InternalTracker.module.css";
import {
  addFeedbackMassase,
  getAllFeedbackMassase,
} from "../../../redux/internal-tracking/InternalSubmissionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";

const CandidatePostFeedbackDrawer = ({
  handleClose,
  show,
  candidate,
  handleShowAddFeedbackBenchSales,
}) => {
  const [feedackValue, setFeedackValue] = useState("");
  const dispatch = useDispatch();
  const oneSubmisionStatus = useSelector(
    (state) => state.trackersubmission.oneSubmisionStatus
  );

  const sendMassage = () => {
    let payloadData = {
      submission: candidate?.submission_id,
      receiver: candidate?.bdm_user_id_for_feedback?.profiles[0]?.userId,
      message: feedackValue,
    };
    dispatch(addFeedbackMassase(payloadData));
  };

  useEffect(() => {
    if (oneSubmisionStatus === "send_feedback_massage") {
      let subID = candidate?.submission_id;
      dispatch(getAllFeedbackMassase(subID));
      handleClose();
      setFeedackValue("");
    }
  }, [oneSubmisionStatus, candidate]);

  const handleOnClickAsk = () => {
    handleShowAddFeedbackBenchSales();
    handleClose();
  };

  const autoResize = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto"; // Reset the height
      textarea.style.height = `${textarea.scrollHeight}px`; // Set it to match content
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "48%",
        padding: "0 0 0 10px",
        borderLeft: "1px solid #f2f2f2",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f2f2f2",
        }}
      >
        <Box className={styles.feedbackHeader}>
          <span>
            <Typography>
              <b>Feedback on {candidate?.full_name}</b>
            </Typography>
            <Typography>
              {candidate?.current_job_title}, Exp {candidate?.total_experience}{" "}
              {candidate?.total_experience > 0 ? "Years" : "Year"}
            </Typography>
          </span>
          {candidate?.bench_sale_user_id_for_feedback !== null && (
            <button onClick={handleOnClickAsk}>Ask to Bench Sales</button>
          )}
        </Box>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ paddingTop: "0" }}>
        <Typography sx={{ margin: "15px 0" }}>
          <b>
            Write to{" "}
            {candidate?.bdm_user_id_for_feedback?.profiles[0]?.fullName} -{" "}
            {candidate?.bdm_user_id_for_feedback?.profiles[0]?.role}
          </b>
        </Typography>
        {/* 
        <textarea
          placeholder="Write Feedback"
          rows={5}
          style={{
            width: "100%",
            padding: "10px",
            border: "1px solid #f2f2f2",
          }}
          onChange={(e) => setFeedackValue(e.target.value)}
        /> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{
            padding: "2px",
            border: "1px solid #f2f2f2",
            borderRadius: "3px",
            margin: "10px",
          }}
        >
          <textarea
            placeholder="Write Feedback"
            rows={5}
            style={{
              overflow: "hidden",
              resize: "none",
              border: "none",
              width: "100%",
            }}
            onChange={(e) => setFeedackValue(e.target.value)}
            onInput={(event) => autoResize(event.target)}
            ref={(el) => el && autoResize(el)}
          />
        </Grid>
        <button
          style={{
            backgroundColor: "#4287f5",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            padding: "9px 15px",
            marginTop: "20px",
            cursor: "pointer",
          }}
          onClick={sendMassage}
          disabled={oneSubmisionStatus === "loading"}
        >
          {oneSubmisionStatus === "loading" ? "Loading" : "Send feedback"}
        </button>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CandidatePostFeedbackDrawer;
